<script setup lang="ts">
// Thin wrapper over markstream-vue's renderer. Its ONLY job is to bind `isDark`
// to our theme once, so every surface (Studio, Home, QuickAsk, Help, FilePreview,
// SkillDetail) renders the Shiki code theme + mermaid/diagrams in the right mode
// without each call site wiring it. The library has no global isDark hook (only a
// per-instance prop), so this wrapper is the single source of truth.
//
// This is the ONLY file that imports the renderer from the library; everything else
// imports this wrapper (keeping the same `MarkdownRender` local name, so templates
// are unchanged). All other props/attrs/slots pass straight through via $attrs.
// The library's --ms-* base palette is bridged separately by a `.dark` class on
// <html> (see stores/theme.ts); together they make rendered markdown fully theme-aware.
import MarkstreamRenderer from 'markstream-vue';
import { computed } from 'vue';
import { useThemeStore } from '@/stores/theme';

defineOptions({ inheritAttrs: false });

const theme = useThemeStore();
const isDark = computed(() => theme.effective === 'dark');
</script>

<template>
  <MarkstreamRenderer :is-dark="isDark" v-bind="$attrs"><slot /></MarkstreamRenderer>
</template>
